import CssVariables from '../../assets/styles/css-variables';
import { makeStylesV5 } from '../index';
export default makeStylesV5()(() => ({
    ExtensivDialogTitle: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontWeight: 800,
        padding: '16px 12px 16px 16px',
    },
    AlertIcon: {
        marginRight: '8px',
        padding: 0
    },
    CloseButton: {
        fontSize: '16px',
        color: CssVariables.primaryMain,
        '&:hover': {
            background: 'transparent'
        }
    },
    DialogContent: {
        padding: '16px'
    },
    ExtensivDialogActions: {
        padding: '8px 16px',
    }
}));
//# sourceMappingURL=styles.js.map